module.exports = __webpack_public_path__ + "static/media/first-img.73cf9fd2.jpg";